export class PaisesEncomendas
{
  paisEncomenda: string;
  armazem: string;
  glnArmazem: string;
  visible: boolean;
}
